import React, {Component} from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import DatePicker from 'react-datepicker';
import {Card, Button, Grid, Dropdown, Input, Icon} from 'semantic-ui-react';
import {dateFormatPicker, noTimeZoneShortISODate} from '../../../common/constants/datesFormat';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {getFilters, getDealers, getAverage} from '../../utils';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import {downloadFile} from '../../../common/util/file';
import VehiclesEfficiencyTable from './table';
import './efficiency.scss';

const today = moment();
const salesTypesOptions = [
  {'text': 'Especiales', 'value': 'TERCEROS'},
  {'text': 'Normal', 'value': 'NORMAL'},
  {'text': 'Todos', 'value': 'TODOS'},
];
const datesTypesOptions = [
  {'text': 'F. Liquidación', 'value': 'liquidationDate'},
  {'text': 'F. Facturación', 'value': 'wholesaleDate'},
];

class VehiclesEfficiency extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'saleTypeFilter': '',
      'dateTypeFilter': datesTypesOptions[0].value,
      'chassisFilter': '',
      'reservedToFilter': '',
      'startDateFilter': today.format(noTimeZoneShortISODate),
      'endDateFilter': today.format(noTimeZoneShortISODate),
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.VehiclesEfficiencyKpi, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchDealers('importers');
    this.onSearchClick();
  }

  componentWillUnmount() {
    this.clearUrlFile();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.urlFile !== this.props.urlFile && this.props.urlFile) {
      downloadFile(this.props.urlFile);
      this.props.clearUrlVehiclesEfficiency();
    }
  }
  
  onSearchClick = () => {
    this.clearUrlFile();
    this.props.clearVehiclesEfficiency();
    const filters = getFilters(this.state);
    this.props.fecthVehiclesEfficiency(filters);
  }

  clearUrlFile = () => {
    const {urlFile} = this.props;
    if (!urlFile) {
      return null;
    }
    this.props.clearUrlVehiclesEfficiency();
  }

  disableCancelButton() {
    const {loading, downloading} = this.props;
    const {saleTypeFilter, dateTypeFilter, chassisFilter, reservedToFilter, startDateFilter} = this.state;
    const emptyAllFilters = !saleTypeFilter && !dateTypeFilter && !chassisFilter && !reservedToFilter &&
    !startDateFilter;

    return loading || downloading || emptyAllFilters;
  }

  onCancelClick = () => {
    this.setState({
      'saleTypeFilter': '',
      'dateTypeFilter': datesTypesOptions[0].value,
      'chassisFilter': '',
      'reservedToFilter': '',
      'startDateFilter': today.format(noTimeZoneShortISODate),
      'endDateFilter': today.format(noTimeZoneShortISODate),
    }, () => {
      this.onSearchClick();
    });
  }

  onDownloadClick = () => {
    const filters = getFilters(this.state);
    this.props.downloadVehiclesEfficiency(filters);
  }

  disableSearchButton = () => {
    const {loading, downloading} = this.props;
    const {saleTypeFilter, dateTypeFilter, chassisFilter, reservedToFilter, startDateFilter} = this.state;
    const requiredFilters = saleTypeFilter || dateTypeFilter || chassisFilter || reservedToFilter || startDateFilter;

    return loading || downloading || !requiredFilters;
  }

  updateSearchFilters = (value, filterName) => {
    this.clearUrlFile();
    const newState = {};
    newState[filterName] = value;
    this.setState(newState);
  }

  updateTextFilters = (filterName, value) => {
    const finalValue = value.toUpperCase();
    this.updateSearchFilters(finalValue, filterName);
  }

  changeStartDate = (date) => {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);
    const {startDateFilter, endDateFilter} = this.state;

    if (dateFormatted !== startDateFilter) {
      this.updateSearchFilters(dateFormatted, 'startDateFilter');
    }
   
    if (!endDateFilter || (endDateFilter && moment(date) > moment(endDateFilter))) {
      this.updateSearchFilters(dateFormatted, 'endDateFilter');
    }
  }

  changeEndDate = (date) => {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);

    if (dateFormatted !== this.state.endDateFilter) {
      this.updateSearchFilters(dateFormatted, 'endDateFilter');
    }
  }

  renderFiltersSection() {
    const {saleTypeFilter, dateTypeFilter, startDateFilter, endDateFilter, chassisFilter,
      reservedToFilter} = this.state;
    const {loading, downloading, dealersList} = this.props;

    return (
      <div className='filters-section'>
        <Grid columns='equal' textAlign='left'>
          <Grid.Row>
            <Grid.Column>
              <Dropdown selection
                options={salesTypesOptions}
                value={saleTypeFilter}
                disabled={loading || downloading}
                onChange={(e, {value}) => this.updateSearchFilters(value, 'saleTypeFilter')}
                placeholder='Tipo de Venta'
              />
            </Grid.Column>
            <Grid.Column>
              <Dropdown selection
                options={datesTypesOptions}
                search
                value={dateTypeFilter}
                disabled={loading || downloading}
                onChange={(e, {value}) => this.updateSearchFilters(value, 'dateTypeFilter')}
                placeholder='Tipo de fecha'
              />
            </Grid.Column>
            <Grid.Column>
              <DatePicker
                customInput={<Input icon='calendar' size='small' />}
                dateFormat={dateFormatPicker}
                selected={startDateFilter ? moment(startDateFilter, noTimeZoneShortISODate).toDate() : null}
                onChange={this.changeStartDate}
                locale='es'
                disabled={loading || downloading}
                placeholderText='Fecha Inicio'
              />
            </Grid.Column>
            <Grid.Column>
              <DatePicker
                customInput={<Input icon='calendar' size='small' />}
                dateFormat={dateFormatPicker}
                selected={endDateFilter ? moment(endDateFilter, noTimeZoneShortISODate).toDate() : null}
                onChange={this.changeEndDate}
                disabled={!startDateFilter || loading || downloading}
                minDate={moment(startDateFilter).toDate()}
                placeholderText='Fecha Fin'
                locale='es'
              />
            </Grid.Column>
            <Grid.Column>
              <Input
                type='text'
                placeholder='Chasis'
                value={chassisFilter}
                disabled={loading || downloading}
                onChange={(e, {value}) => this.updateTextFilters('chassisFilter', value)}
              />
            </Grid.Column>
            <Grid.Column>
              <Dropdown selection
                options={getDealers(dealersList)}
                search
                value={reservedToFilter}
                disabled={loading || downloading}
                onChange={(e, {value}) => this.updateSearchFilters(value, 'reservedToFilter')}
                placeholder='Reservado'
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }

  render() {
    const {loading, downloading, vehiclesList} = this.props;
    return (
      <div className='vehicles-efficiency-page'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Eficiencia de Vehículos</h2>
              <div className='title-bar-actions'>
                <Button
                  type='button'
                  secondary
                  className='toyota-secondary'
                  disabled={this.disableCancelButton()}
                  onClick={this.onCancelClick}
                >
                  Limpiar
                </Button>
                <Button
                  primary
                  type='button'
                  className='toyota-primary download'
                  disabled={loading || downloading}
                  loading={downloading}
                  onClick={this.onDownloadClick}
                >
                  <Icon name='download' />
                  Excel
                </Button>
                <Button
                  primary
                  type='button'
                  className='toyota-primary'
                  disabled={this.disableSearchButton()}
                  onClick={this.onSearchClick}
                >
                  Buscar
                </Button>
              </div>
            </div>
            <Grid
              columns='equal'
              textAlign='center'
              className='average-container'
            >
              <Grid.Row>
                <Grid.Column>
                  <h4>Promedio Wholesale - Cambio Estado: </h4>
                  {getAverage('difWholesaleAndChange', vehiclesList)}
                </Grid.Column>
                <Grid.Column>
                  <h4>Promedio Wholesale - Priorización:</h4>
                  {getAverage('difWholesaleAndPriority', vehiclesList)}
                </Grid.Column>
              </Grid.Row>
            </Grid>
            {this.renderFiltersSection()}
          </div>
        </Card>

        <VehiclesEfficiencyTable />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingDealer': state.dealer.loading,
    'dealersList': state.dealer.list,
    'loading': state.vehicleEfficiency.loading,
    'vehiclesList': state.vehicleEfficiency.list,
    'downloading': state.vehicleEfficiency.downloading,
    'urlFile': state.vehicleEfficiency.urlFile,
    'permissions': state.session.permissions,
  };
};

const {
  navigateTo,
  clearVehiclesEfficiency,
  fecthVehiclesEfficiency,
  fetchDealers,
  clearUrlVehiclesEfficiency,
  downloadVehiclesEfficiency,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  clearVehiclesEfficiency,
  fecthVehiclesEfficiency,
  fetchDealers,
  clearUrlVehiclesEfficiency,
  downloadVehiclesEfficiency,
})(VehiclesEfficiency);
